module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "id": "pg_10",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "Funkydori_Regular_17"
  }, [_vm._v("Using Patterns")])])])]), _vm._v(" "), _c('p', {
    staticClass: "COS"
  }, [_vm._v("You can download full-size printable versions of the patterns from "), _c('a', {
    attrs: {
      "href": "http://www.davidandcharles.com",
      "target": "_blank"
    }
  }, [_vm._v("www"), _c('wbr'), _vm._v(".davidandcharles"), _c('wbr'), _vm._v(".com")]), _vm._v(". Some of the projects have two or more pattern pieces (which are indicated on the patterns), others have just one pattern piece and some projects simply use rectangles given as measurements within the project instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-1"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("1")]), _vm._v(" Get a large sheet of suitable paper. I usually use pale tissue paper, but you can also use tracing paper, greaseproof (wax) paper or dressmaking paper. Iron the paper and the pattern sheet on a low setting.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-2"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("2")]), _vm._v(" Lay the paper over your chosen pattern piece and, using pins or sticky tape, secure the paper to the pattern so that it can’t move around.")]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-3"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("3")]), _vm._v(" Take a soft leaded pencil (you don’t want to rip holes in your paper with a hard pencil) and trace around your pattern shape. Also trace the various pattern markings, notches and darts if appropriate. See "), _c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fig-a"
    }
  }, [_vm._v("Fig a")])]), _vm._v(".")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "237",
      "id": "fig-a",
      "src": "images/pg10-1.jpg",
      "width": "390"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "CAP"
  }, [_c('b', [_vm._v("Fig a")]), _vm._v(" Use a soft leaded pencil to trace the pattern and pattern markings to get nice easy-to-see outlines – and you’ll avoid ripping the paper.")])])]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-4"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("4")]), _vm._v(" Lay out your traced pattern pieces onto your fabric. Align your pattern with the fabric’s straight grain. If the pattern piece instructs you to place it on a fold, fold your fabric as shown in "), _c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fig-b"
    }
  }, [_vm._v("Fig b")])]), _vm._v(". Pay attention to the direction of your pattern – are the pattern pieces the right way up? Accordingly, is the pattern on your fabric also the right way up?")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "237",
      "id": "fig-b",
      "src": "images/pg10-2.jpg",
      "width": "390"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "CAP"
  }, [_c('b', [_vm._v("Fig b")]), _vm._v(" To place a pattern piece on a fold, fold the fabric wrong sides together and position the fold line of the pattern onto the folded edge of the fabric.")])])]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-5"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("5")]), _vm._v(" Pin your pattern pieces to your fabric and cut the fabric around the pattern shapes. See "), _c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fig-c"
    }
  }, [_vm._v("Fig c")])]), _vm._v(". Alternatively, you can pin your patterns to your fabric and then trace around the outline of your pattern pieces with disappearing marker or chalk to get an outline for fabric cutting.")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "236",
      "id": "fig-c",
      "src": "images/pg11-1.jpg",
      "width": "390"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "CAP"
  }, [_c('b', [_vm._v("Fig c")]), _vm._v(" I prefer to pin and cut around the pattern pieces because it’s faster than tracing the pattern and then cutting.")])])]), _vm._v(" "), _c('p', {
    staticClass: "STEP-TEXT",
    attrs: {
      "id": "step-6"
    }
  }, [_c('span', {
    staticClass: "eSANS_NUMBER"
  }, [_vm._v("6")]), _vm._v(" Transfer any pattern markings and notches from the pattern piece to your fabric pieces using chalk or disappearing marker. See "), _c('b', [_c('a', {
    attrs: {
      "href": "#/xhtml/#fig-d"
    }
  }, [_vm._v("Fig d")])]), _vm._v(".")]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "236",
      "id": "fig-d",
      "src": "images/pg11-2.jpg",
      "width": "390"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "CAP"
  }, [_c('b', [_vm._v("Fig d")]), _vm._v(" While the pattern is still pinned to the fabric, transfer the various pattern markings onto the fabric.")])])]), _vm._v(" "), _c('div', {
    staticClass: "tip-nobot"
  }, [_c('p', {
    staticClass: "TIPH"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Heavy"
  }, [_vm._v("Label snob …")])]), _vm._v(" "), _c('p', {
    staticClass: "TIP-TEXT"
  }, [_c('samp', {
    staticClass: "SANS_Tiva_Regular_17"
  }, [_vm._v("Label your pattern pieces before use. After using them, fold them carefully and store in an envelope. Also store in the envelope any notes you make during bag construction, ready for next time.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 72
// module chunks = 0